export const geoAPIOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '38fdc3c67fmsh84ac2bde703904cp10ddc8jsn897a9e0c3381',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo';

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "b1f1844067a5a5d97887ad1e5b8165e1";